var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrunkLockedSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,18c-3.3085938,0-6,2.6914062-6,6H0v2h6.3500977C7.1762695,28.3265991,9.3935547,30,12,30c3.3085938,0,6-2.6914062,6-6 S15.3085938,18,12,18z M12,28c-2.2060547,0-4-1.7944336-4-4s1.7939453-4,4-4s4,1.7944336,4,4S14.2060547,28,12,28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,22v-2c0-2.2055664-1.7939453-4-4-4s-4,1.7944336-4,4v2c-1.1025391,0-2,0.8969727-2,2v6c0,1.1030273,0.8974609,2,2,2h8 c1.1025391,0,2-0.8969727,2-2v-6C32,22.8969727,31.1025391,22,30,22z M24,20c0-1.1030273,0.8974609-2,2-2s2,0.8969727,2,2v2h-4V20z  M30,30h-8v-6h8V30z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 26,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9013672,14H14v2h5.0000019C19.5522861,16,20,15.5522852,20,15.000001V15c0-2.557251-1.248291-3.9285278-2-4.5241699 V9.6225586c0-1.1839666-0.1911335-2.3601694-0.5660229-3.4832168l-0.0689869-0.2066636C18.1165771,5.1739502,19.6571045,4,22,4h6V2 h-6c-2.6140137,0-4.4648438,1.1221313-5.5771484,2.086853l-0.1064453-0.0355835C16.0654297,3.9677734,10.046875,2,0,2v2 c6.072998,0,8.6396484,3.9240112,9.5726318,6H0v2h16.7099609C17.0195312,12.2290039,17.6572266,12.8286133,17.9013672,14z M16,10 h-4.2839355c-0.4649658-1.2282715-1.6623535-3.7064209-4.1306152-5.5877686 c3.9476318,0.4386597,6.609375,1.1081543,7.6303711,1.3968506l0.3232422,0.9677734C15.8447266,7.6953125,16,8.652832,16,9.6225586 V10z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrunkLockedSmall);
export default __webpack_public_path__ + "static/media/trunk-locked--small.28418f548525cf54eeb3b22c526d1872.svg";
export { ForwardRef as ReactComponent };